<script setup>
import { ref, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

defineProps({
    visible: Boolean,
    loading: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:visible', 'confirm']);

const message = ref('');

const handleConfirm = () => {
    emit('confirm', message.value.trim() || null);
    message.value = '';
};

const handleClose = () => {
    message.value = '';
    emit('update:visible', false);
};
</script>

<template>
    <Dialog
        :visible="visible"
        @update:visible="(v) => { if (!v) handleClose(); }"
        modal
        :header="$t('Force Approve Content')"
        :style="{ width: '500px' }"
        :breakpoints="{ '640px': '95vw' }"
    >
        <div class="space-y-4">
            <div class="flex items-start gap-3 p-4 bg-amber-50 border border-amber-200 rounded-lg">
                <i class="pi pi-shield text-amber-500 text-xl mt-0.5"></i>
                <p class="text-surface-700 text-sm">
                    {{ $t('This will approve the content on behalf of the client, bypassing their review step.') }}
                </p>
            </div>
            <div>
                <label class="block text-sm font-medium text-surface-700 mb-2">
                    {{ $t('Message (Optional)') }}
                </label>
                <Textarea
                    v-model="message"
                    rows="3"
                    class="w-full"
                    :placeholder="$t('Add a note explaining this approval...')"
                    :disabled="loading"
                />
            </div>
        </div>
        <template #footer>
            <div class="flex justify-end gap-3">
                <Button
                    :label="$t('Cancel')"
                    severity="secondary"
                    :disabled="loading"
                    @click="handleClose"
                />
                <Button
                    :label="$t('Force Approve')"
                    icon="pi pi-shield"
                    severity="warning"
                    :loading="loading"
                    @click="handleConfirm"
                />
            </div>
        </template>
    </Dialog>
</template>
